import { FC } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { ChakraAppLoader } from 'app/components/Core';
import { config } from 'config';
import { useIsMobile } from 'app/utils/hooks';
import { getRedirectPath } from 'app/views/SignInRedirect/utils';

export const SignInRedirect: FC = () => {
  const location = useLocation();
  const { state: locationState, search } = location;
  const basename = config.publicUrl || config.basename;
  const isMobile = useIsMobile();
  const redirectPath = getRedirectPath({ isMobile, locationState, search });

  if (config.isElectronBuild || config.isFeatureBuild) {
    return (
      <Navigate
        to={{ pathname: redirectPath, search }}
        state={locationState}
        replace
      />
    );
  }

  window.location.replace(basename + redirectPath + search);

  return <ChakraAppLoader />;
};
